import React from 'react';
import BasicButton from 'Components/common/BasicButton';
import BasicInput from 'Components/common/BasicInput';
import Dialog from 'Components/common/Dialog';
import ShipmentReceiveWithOtherPhotosDialog from 'Components/host/ShipmentReceiveWithOtherPhotosDialog';
import {T} from 'Actions/translate';

const HostShipmentDetailsDialogs = ({
    hostShipmentDetail,
    shipmentCard,
    isReceiveDialogOpened,
    isWithdrawalDialogOpened,
    isWithdrawalPending,
    isTrackingDialogOpened,
    isPlacementPreviewOpened,
    trackingNumber,
    uploadFileBtnIsLoading,
    getPreviewImageUrl,
    onCloseReceive,
    onCloseWithdrawal,
    onWithdraw,
    onCloseTracking,
    onTrackingNumberChange,
    onUpdateTrackingNumber,
    onClosePlacementPreview,
    onReceiveLoadingChange,
    onReceiveSuccess,
}) => {
    return (
        <>
            <Dialog
                opened={isWithdrawalDialogOpened}
                dialogDidClose={onCloseWithdrawal}
                options={{bgClickClose: !isWithdrawalPending}}>
                <div className="cancel-order-dialog">
                    <h5 className="cancel-order-dialog-title text-center">
                        {T('withdrawal_of_package')}
                    </h5>
                    <p className="cancel-order-dialog-desc shipment-detail-cancel-package">
                        {T('confirm_cancellation_of_package')}
                    </p>
                    <div className="button-contanier">
                        <BasicButton
                            type="primary"
                            className="confirm-action-btn confirm-cancel-btn"
                            disabled={isWithdrawalPending}
                            onClickOfSingleTap={onCloseWithdrawal}>
                            {T('btn_action_cancel')}
                        </BasicButton>
                        <BasicButton
                            type="primary"
                            className="cancel-order-confirm-btn"
                            disabled={isWithdrawalPending}
                            loading={isWithdrawalPending}
                            onClickOfSingleTap={onWithdraw}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </div>
            </Dialog>
            <Dialog
                opened={isReceiveDialogOpened}
                dialogDidClose={onCloseReceive}
                options={{bgClickClose: !uploadFileBtnIsLoading}}>
                <ShipmentReceiveWithOtherPhotosDialog
                    opened={isReceiveDialogOpened}
                    uploadFileBtnIsLoading={uploadFileBtnIsLoading}
                    onClose={onCloseReceive}
                    maskedPhone={
                        hostShipmentDetail && hostShipmentDetail.receiverTel
                    }
                    shipment={hostShipmentDetail}
                    shipmentId={shipmentCard && shipmentCard.shipmentId}
                    onLoadingChange={onReceiveLoadingChange}
                    onSuccess={onReceiveSuccess}
                />
            </Dialog>
            <Dialog
                opened={isTrackingDialogOpened}
                dialogDidClose={onCloseTracking}
                options={{bgClickClose: true}}>
                <div className="track-number-dialog">
                    <h5 className="track-number-dialog-title text-center">
                        {T('shippment_input_tracking_number')}
                    </h5>
                    <div className="input-track-number">
                        <BasicInput
                            placeholder={T(
                                'shippment_please_input_tracking_number',
                            )}
                            title=""
                            className="track-number-basic-input"
                            value={trackingNumber}
                            inputValid={onTrackingNumberChange}
                        />
                    </div>
                    <BasicButton
                        type="primary"
                        className="add-track-number-confirm-btn"
                        onClickOfSingleTap={onUpdateTrackingNumber}>
                        {T('shippment_confirm')}
                    </BasicButton>
                </div>
            </Dialog>
            <Dialog
                opened={isPlacementPreviewOpened}
                dialogDidClose={onClosePlacementPreview}
                options={{bgClickClose: true}}>
                <div className="preview-shipment-receive-image-dialog">
                    {shipmentCard && shipmentCard.locationImg ? (
                        <img
                            src={getPreviewImageUrl(shipmentCard.locationImg)}
                            alt=""
                        />
                    ) : null}
                </div>
            </Dialog>
        </>
    );
};

export default HostShipmentDetailsDialogs;
